(function(){
  'use strict';
  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn,{once:true});else fn();}
  function key(url){try{var u=new URL(url,location.href);return u.hostname+u.pathname.replace(/_[0-9]+x[0-9]*\.(jpg|jpeg|png|webp)$/i,'.$1');}catch(e){return String(url||'').split('?')[0];}}
  ready(function(){
    var root=document.querySelector('.lbx-product-pro');if(!root)return;
    var seen=new Set();var kept=[];
    root.querySelectorAll('[data-lbx-thumbnail]').forEach(function(btn){
      var k=key(btn.getAttribute('data-image-src')||'');
      if(!k){kept.push(btn);return;}
      if(seen.has(k)){btn.remove();return;}
      seen.add(k);kept.push(btn);
    });
    root.querySelectorAll('[data-lbx-mobile-gallery-dot]').forEach(function(dot,index){if(index>=kept.length)dot.remove();});
    kept.forEach(function(btn,index){btn.setAttribute('data-lbx-gallery-index',String(index));});
    root.querySelectorAll('[data-lbx-mobile-gallery-dot]').forEach(function(dot,index){dot.setAttribute('data-lbx-mobile-gallery-index',String(index));});

    root.querySelectorAll('[data-lbx-size-guide-modal],[data-lbx-preorder-modal],[data-lbx-wishlist-modal]').forEach(function(modal){
      if(!modal.classList.contains('is-open')){modal.hidden=true;modal.setAttribute('aria-hidden','true');}
    });

    function getSizeModal(){return root.querySelector('[data-lbx-size-guide-modal]');}
    function openSizeGuideFallback(){
      var modal=getSizeModal();if(!modal)return;
      modal.hidden=false;modal.classList.add('is-open');modal.setAttribute('aria-hidden','false');
      document.documentElement.style.overflow='hidden';
      var input=modal.querySelector('[data-lbx-height-input]');
      if(input)window.setTimeout(function(){
        try{input.dispatchEvent(new Event('input',{bubbles:true}));}catch(e){}
        try{input.focus({preventScroll:true});}catch(e){input.focus();}
      },20);
    }
    function closeSizeGuideFallback(){
      var modal=getSizeModal();if(!modal)return;
      modal.classList.remove('is-open');modal.hidden=true;modal.setAttribute('aria-hidden','true');
      document.documentElement.style.overflow='';
    }
    root.addEventListener('click',function(event){
      var open=event.target.closest('[data-lbx-size-guide-open],[data-mg2-size-guide]');
      if(open){event.preventDefault();window.setTimeout(function(){var m=getSizeModal();if(m&&m.hidden)openSizeGuideFallback();},0);return;}
      if(event.target.closest('[data-lbx-size-guide-close]')){event.preventDefault();closeSizeGuideFallback();}
    },true);
    document.addEventListener('keydown',function(event){if(event.key==='Escape'){var m=getSizeModal();if(m&&!m.hidden)closeSizeGuideFallback();}});

    function unlockIfIdle(){
      var openDialog=root.querySelector('[data-lbx-size-guide-modal].is-open,[data-lbx-preorder-modal].is-open,[data-lbx-wishlist-modal].is-open');
      if(!openDialog){document.documentElement.classList.remove('mg2-lock');document.body.classList.remove('mg2-lock');}
    }
    unlockIfIdle();window.addEventListener('pageshow',unlockIfIdle);
  });
})();
